export enum ServerEventType {
    UserAdded = 'USER_ADDED',
    UserDeleted = 'USER_DELETED',
    UserUpdated = 'USER_UPDATED'
}
